export function Index(organizationID: number, formID: number): string {
	return `/v1/organizations/${organizationID}/forms/${formID}/packages`;
}

export function Show(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/views/forms/packages/${ID}`;
}

export function Upsert(organizationID: number, formID: number): string {
	return `/v1/organizations/${organizationID}/forms/${formID}/packages`;
}

